import React, { Component } from 'react';
import classNames from 'classnames';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Function} [onClick]
 * @prop {boolean} [right]
 * @prop {String} [className]
 *
 * @augments {Component<Props>}
 */
export default class PaginationButton extends Component {

	genClassName = (props) => classNames('PaginationButton', props.className, {
		left: !props.right,
		right: props.right,
	});

	render () {
		return (
			<button
				type='button'
				className={this.genClassName(this.props)}
				onClick={this.props.onClick}
				aria-label={this.props.right ? 'Next' : 'Previous'}
			/>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/PaginationButton/PaginationButton.js